import { useLayoutEffect } from "react";

export const SITE_NAME = "CineParagon";

export const DEFAULT_META_DESCRIPTION =
  "Track your movies, earn achievements, compare your taste with friends and discover new films on CineParagon.";

export const DEFAULT_META_DESCRIPTIONS = {
  ru: "Отмечайте просмотренные фильмы, получайте достижения, сравнивайте вкусы с друзьями и находите новое кино на CineParagon.",
  en: DEFAULT_META_DESCRIPTION
};

export const getDefaultMetaDescription = (language: string = "en"): string =>
  DEFAULT_META_DESCRIPTIONS[String(language).toLowerCase().startsWith("ru") ? "ru" : "en"];

const normalizeTitle = (title: string): string => {
  const cleanTitle = String(title || "").trim();
  if (!cleanTitle) return SITE_NAME;
  return cleanTitle.includes(SITE_NAME) ? cleanTitle : `${cleanTitle} | ${SITE_NAME}`;
};

const getOrCreateMetaDescription = (): HTMLMetaElement => {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (meta) return meta;

  meta = document.createElement("meta");
  meta.setAttribute("name", "description");
  document.head.appendChild(meta);
  return meta;
};

export const usePageMeta = (title?: string | null, description: string | null = DEFAULT_META_DESCRIPTION): void => {
  useLayoutEffect(() => {
    if (typeof document === "undefined") return;

    if (title != null) {
      document.title = normalizeTitle(title);
    }
    if (description != null) {
      getOrCreateMetaDescription().setAttribute(
        "content",
        description || DEFAULT_META_DESCRIPTION
      );
    }
  }, [title, description]);
};
